// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomAccordion_wrapper__VSxDG","questionWrapper":"CustomAccordion_questionWrapper__iqTLc","answerWrapper":"CustomAccordion_answerWrapper__-miKr"};